export default class RenameQueryModalController {
  queryName: string;

  static $inject = ['$uibModalInstance'];

  constructor(private $uibModalInstance) {}

  saveAndClose() {
    this.$uibModalInstance.close({
      name: this.queryName,
    });
  }
}
